import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ContactsIcon from '@mui/icons-material/Contacts';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SelectCompany from '../select/SelectCompany';
import SelectContact from '../select/SelectContact';
import { useTranslation } from 'react-i18next';
import SelectLeadCompany from '../select/SelectLeadCompany';
import SelectLeadPerson from '../select/SelectLeadPerson';

const StepRecipient = ({
  updateDataCollection,
  dataCollection,
  updateValidation,
  key = 'recipient',
  showLeads = false,
}) => {
  const { t } = useTranslation();

  const [type, setType] = useState("company");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (dataCollection[key + 'Type']) {
      updateValidation(dataCollection.recipient !== undefined);
      setType(dataCollection[key + 'Type']);
    }
  }, [dataCollection]);

  function handleDelivertype(event, newType) {
    if (newType) {
      setType(newType);
    }
  }

  function handleCompanySelect(company) {
    const insertData = {
      [key + 'Type']: 'company',
      [key]: company,
      templateId: null,
    };
    updateDataCollection(insertData);
  }

  function handleContactSelect(contact) {
    const insertData = {
      [key + 'Type']: 'contact',
      [key]: contact,
      templateId: null,
    };
    updateDataCollection(insertData);
  }

  function handleCompanyLeadSelect(companyLead) {
    let leadData = { ...companyLead };

    if (!companyLead?.address) {
      leadData = {
        ...companyLead,
        address: {
          addressAddition: '',
          city: '',
          country: '',
          countryCode: '',
          houseNumber: '',
          street: '',
          zipCode: '',
        },
      };
    }

    const insertData = {
      [key + 'Type']: 'company_lead',
      [key]: leadData,
      templateId: null,
    };
    updateDataCollection(insertData);
  }

  function handlePersonLeadSelect(personLead) {
    console.log(personLead, 'person_lead');

    let leadData = { ...personLead };

    if (!personLead?.address) {
      leadData = {
        ...personLead,
        address: {
          addressAddition: '',
          city: '',
          country: '',
          countryCode: '',
          houseNumber: '',
          street: '',
          zipCode: '',
        },
      };
    }
    const insertData = {
      [key + 'Type']: 'person_lead',
      [key]: leadData,
      templateId: null,
    };
    updateDataCollection(insertData);
  }

  return (
    <Box className="h-full">
      <ToggleButtonGroup value={type} exclusive onChange={handleDelivertype}>
        <ToggleButton value="company">
          <Tooltip title={t('Companies')}>
            <ApartmentIcon />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value="contact">
          <Tooltip title={t('Contacts')}>
            <ContactsIcon />
          </Tooltip>
        </ToggleButton>
        {showLeads && (
          <>
            <ToggleButton value="company_lead">
              <Tooltip title={t('Lead Companies')}>
                <StorefrontIcon />
              </Tooltip>
            </ToggleButton>
            <ToggleButton value="person_lead">
              <Tooltip title={t('Lead Contacts')}>
                <PersonSearchIcon />
              </Tooltip>
            </ToggleButton>
          </>
        )}
      </ToggleButtonGroup>
      <Box
        className="pt-2"
        sx={{
          height: 'calc(100% - 45px - 4px)',
        }}
      >
        {type === 'company' && (
          <SelectCompany
            onSelect={handleCompanySelect}
            preSelected={dataCollection[key]}
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
          />
        )}
        {type === 'contact' && (
          <SelectContact
            onSelect={handleContactSelect}
            preSelected={dataCollection[key]}
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
          />
        )}
        {type === 'company_lead' && (
          <SelectLeadCompany
            onSelect={handleCompanyLeadSelect}
            preSelected={dataCollection[key]}
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
          />
        )}
        {type === 'person_lead' && (
          <SelectLeadPerson
            onSelect={handlePersonLeadSelect}
            preSelected={dataCollection[key]}
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
          />
        )}
      </Box>
    </Box>
  );
};

export default StepRecipient;
